module.exports = __webpack_public_path__ + "static/img/Alex-Chidiac.9cd78cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Alex-Chidiac.jpg
// module id = P0ji
// module chunks = 0